/**
 * Kapitaal - Kapitaalsvergelijking
 * EXACT zoals Morris kapitaal.html
 */

import { useState, useEffect } from 'react';
import BoekhoudingLayout from '../../components/boekhouding/BoekhoudingLayout';
import styles from '../../styles/Boekhouding.module.css';
import { boekhoudingService, KapitaalData } from '../../services/boekhouding.service';

const Kapitaal = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<KapitaalData | null>(null);

  // Huidig boekjaar uit localStorage
  const huidigJaar = parseInt(localStorage.getItem('boekhouding_jaar') || new Date().getFullYear().toString());

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const result = await boekhoudingService.getKapitaal(huidigJaar);
        setData(result);
      } catch (err) {
        console.error('Error loading kapitaal:', err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [huidigJaar]);

  const formatBedrag = (bedrag: number): string => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format(bedrag || 0);
  };

  if (loading) {
    return (
      <BoekhoudingLayout title={`Kapitaalsvergelijking ${huidigJaar}`}>
        <div className={styles.loading}>Laden...</div>
      </BoekhoudingLayout>
    );
  }

  if (!data) {
    return (
      <BoekhoudingLayout title={`Kapitaalsvergelijking ${huidigJaar}`}>
        <div className={styles.error}>Kon kapitaal data niet laden</div>
      </BoekhoudingLayout>
    );
  }

  return (
    <BoekhoudingLayout title={`Kapitaalsvergelijking ${huidigJaar}`}>
      {/* EXACT Morris: kapitaal-container max-width 400px */}
      <div className={styles.kapitaalContainer}>
        <div className={styles.card}>
          <h3 className={styles.kapitaalHeader}>Kapitaalsvergelijking {huidigJaar}</h3>
          <table className={styles.kapitaalTable}>
            <tbody>
              <tr>
                <td>1-1-{huidigJaar}</td>
                <td className={styles.alignRight}>{formatBedrag(data.begin_saldo)}</td>
              </tr>
              <tr>
                <td>Winst</td>
                <td className={`${styles.alignRight} ${styles.positief}`}>{formatBedrag(data.winst)}</td>
              </tr>
              <tr>
                <td>Opgenomen (netto)</td>
                <td className={`${styles.alignRight} ${styles.negatief}`}>{formatBedrag(data.prive_opnames_netto)}</td>
              </tr>
              {data.or_dotatie > 0 && (
                <tr>
                  <td>Dotatie OR</td>
                  <td className={`${styles.alignRight} ${styles.negatief}`}>{formatBedrag(data.or_dotatie)}</td>
                </tr>
              )}
              <tr className={styles.separatorRow}>
                <td></td>
                <td className={styles.alignRight}>========</td>
              </tr>
              <tr className={styles.totaalRow}>
                <td>31-12-{huidigJaar}</td>
                <td className={styles.alignRight}><strong>{formatBedrag(data.eind_saldo)}</strong></td>
              </tr>
              <tr>
                <td>Oudedagsreserve</td>
                <td className={styles.alignRight}>{formatBedrag(data.oudedagreserve)}</td>
              </tr>
              <tr className={styles.separatorRow}>
                <td></td>
                <td className={styles.alignRight}>========</td>
              </tr>
              <tr className={styles.eindtotaalRow}>
                <td><strong>Eigen vermogen</strong></td>
                <td className={styles.alignRight}><strong>{formatBedrag(data.eigen_vermogen)}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </BoekhoudingLayout>
  );
};

export default Kapitaal;
